import React, {useCallback, useState} from 'react';
import {PDFOption} from 'shared/components/Header/helper/usePDFLinks';
import OutsideClickHandler from 'shared/components/Header/OutsideClickHandler';
import {Dropdown} from 'react-bootstrap';
import {Icon} from 'shared/helpers';

interface PDFDropdownProps {
    dialog: JSX.Element;
    dropDowns: PDFOption[];
    className?: string;
    smallButton?: boolean;
    label?: string;
}

export const PDFDropdown = ({
    dialog,
    dropDowns,
    className,
    smallButton = true,
    label = 'PDF',
}: PDFDropdownProps) => {
    const [showPdfDropdown, setShowPdfDropdown] = useState(false);

    const onOutsideClickFunc = useCallback(() => {
        setShowPdfDropdown(false);
    }, []);

    const handleClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent event from bubbling up
        setShowPdfDropdown((prevState) => !prevState); // Toggle dropdown state
    }, []); // Dependency array is empty, so this function won't change

    const handleBlur = useCallback((e: React.FocusEvent) => {
        // Only hide if click outside of dropdown
        const target = e.relatedTarget as HTMLElement;
        const clickNode =
            target && target.nodeName === 'A' ? e.relatedTarget : e.target;

        if (
            clickNode &&
            'click' in clickNode &&
            typeof clickNode.click === 'function'
        ) {
            clickNode.click(); // Simulate click on the related target
        }

        setShowPdfDropdown(false); // Hide the dropdown
    }, []); // No dependencies, this will not change

    return (
        <>
            {dialog}
            <OutsideClickHandler onOutsideClick={onOutsideClickFunc}>
                <Dropdown
                    className="table-option-dropdown pdfDropDownCart"
                    show={showPdfDropdown}
                    drop="down"
                    onBlur={handleBlur}>
                    <Dropdown.Toggle
                        variant="link"
                        className={`${className} button-blue ${smallButton ? 'btn-sm' : ''}`}
                        onClick={handleClick}>
                        <Icon iconName="Button-Create-PDF.svg" />
                        <span>{label}</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu renderOnMount={true}>
                        {dropDowns?.length > 0
                            ? dropDowns.map((option) => {
                                  if (option.hasOwnProperty('show')) {
                                      if (
                                          typeof option.show === 'boolean' &&
                                          !option.show
                                      )
                                          return null;
                                  }
                                  return (
                                      <Dropdown.Item
                                          href={option?.link}
                                          onClick={option?.onClick}
                                          target="_blank"
                                          key={option.name}>
                                          {option.name}
                                      </Dropdown.Item>
                                  );
                              })
                            : null}
                    </Dropdown.Menu>
                </Dropdown>
            </OutsideClickHandler>
        </>
    );
};
